import { ViewEditModeContextProvider } from 'app/context/ViewEditModeContext/ViewEditModeContext';

import { Experience } from '../Common/Experience';

export const ExperienceCreation = () => {
  return (
    <ViewEditModeContextProvider>
      <Experience />
    </ViewEditModeContextProvider>
  );
};
